export default {
    SET_GUIDANCE_LOADING: 'SET_GUIDANCE_LOADING',
};
